import { render, staticRenderFns } from "./ReprintRequest.vue?vue&type=template&id=6fc9f849&"
import script from "./ReprintRequest.vue?vue&type=script&lang=js&"
export * from "./ReprintRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports